"use strict";

var e = require("../widowBlock-bd32f3ea.js");
require("react"), require("prop-types"), require("../taggedTemplateLiteral-97b463ad.js"), require("../_commonjsHelpers-f10b257f.js"), require("styled-components"), module.exports = e.WidowBlockComponent;